<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="3">
          <v-btn
            @click="openFormDialog"
            class="accent shadow-4 px-8"
            color="success"
            large
            rounded
          >
            Crear Registro
          </v-btn>
        </v-col>
        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1 mt-5 mt-md-10">
      <v-data-table
        :search="search"
        :headers="headers"
        :items="directoryList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        no-data-text="No hay registros que mostrar"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.departament_id`]="{ item }">
          {{ item.departament.name }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleEdit(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-tooltip color="blue-grey" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="handleCallDialog(item)"
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'error' : 'blue-grey'"
                >
                  <v-icon>mdi-phone</v-icon>
                </v-btn>
              </template>
              <span>Llamar</span>
            </v-tooltip>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="handleDelete(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <!-- Form dialog -->
    <directory-form
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="registerToEdit"
      :departmentList="departmentList"
      @close:dialog="closeFormDialog"
    ></directory-form>
    <!-- Call dialog -->
    <call-dialog
      v-if="isOpenCall"
      :isActive="isOpenCall"
      :registerToCall="registerToCall"
      @close:dialog="closeCallDialog"
    ></call-dialog>
    <!-- Delete dialog -->
    <delete-dialog
      v-if="isOpenDelete"
      :isActive="isOpenDelete"
      :id="registerToDelete.id"
      @dialog:close="closeDeleteDialog"
    ></delete-dialog>
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import CallDialog from "@/components/Directory/CallDialog";
import DirectoryForm from "@/components/Directory/DirectoryForm.vue";
import DeleteDialog from "@/components/Directory/DeleteDialog.vue";

export default {
  name: "DirectoryList",

  props: {
    department: {
      type: Object,
    },
  },

  components: { CallDialog, DirectoryForm, DeleteDialog },

  data() {
    return {
      isLoading: false,
      isOpenForm: false,
      isOpenDelete: false,
      isEditMode: false,
      isOpenCall: false,
      search: "",
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      directoryList: [],
      departmentList: [],
      registerToEdit: {},
      registerToDelete: {},
      registerToCall: {},
      headers: [
        {
          text: "Nombre",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Departamento",
          value: "departament_id",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Extension",
          value: "extension",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false,
        },
      ],
    };
  },

  watch: {
    options: {
      handler() {
        this.getContacts();
      },
      deep: true,
    },
  },

  created() {
    // this.getContacts();
    this.getDepartments();
  },

  methods: {
    async getContacts() {
      const { page } = this.options || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get("/admin/directory", {
          params: { page, itemPerPage },
        });
        // console.log("data", data);
        this.totalItems = data.total;
        this.directoryList = data.data;
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },

    async getDepartments() {
      try {
        const { data } = await PbxHttpClient.get("/admin/departaments");
        this.departmentList = data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener los departamentos.", "¡Error!");
      }
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.registerToEdit = item;
      this.openFormDialog();
    },
    handleDelete(item) {
      this.registerToDelete = item;
      this.isOpenDelete = true;
    },

    handleCallDialog(item) {
      this.registerToCall = item;
      this.isOpenCall = true;
    },

    openFormDialog() {
      this.isOpenForm = true;
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode)
        this.directoryList = this.directoryList.map((el) =>
          el.id === data.id ? data : el
        );
      if (data && !this.isEditMode)
        this.directoryList = [...this.directoryList, data];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.registerToEdit = {};
    },
    closeDeleteDialog(data = false) {
      if (data)
        this.directoryList = this.directoryList.filter(
          (el) => el.id !== this.registerToDelete.id
        );
      this.isOpenDelete = false;
      this.registerToDelete = {};
    },

    closeCallDialog() {
      this.isOpenCall = false;
    },
  },
};
</script>

<style></style>
